// urs-Logo — Bot + Wortmarke "urs" (Anton, in Pfade umgewandelt, font-unabhaengig).
// Farbe folgt currentColor, passt sich damit Light/Dark automatisch an.

export function UrsBot({ size = 40, className, style }) {
  return (
    <svg className={className} style={style} width={size} viewBox="6.5 8 87 81.5"
         fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="urs">
      <rect x="46.5" y="8" width="7" height="24" rx="3.5" fill="currentColor" />
      <rect x="10" y="42" width="80" height="44" rx="13" fill="none" stroke="currentColor" strokeWidth="7" />
      <circle cx="34" cy="64" r="6" fill="currentColor" />
      <circle cx="66" cy="64" r="6" fill="currentColor" />
    </svg>
  )
}

export function UrsLogo({ width = 120, className, style }) {
  return (
    <svg className={className} style={style} width={width} viewBox="0 0 300 467.55"
         fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="urs">
      <g transform="scale(3.44828) translate(-6.5,-8)">
        <rect x="46.5" y="8" width="7" height="24" rx="3.5" fill="currentColor" />
        <rect x="10" y="42" width="80" height="44" rx="13" fill="none" stroke="currentColor" strokeWidth="7" />
        <circle cx="34" cy="64" r="6" fill="currentColor" />
        <circle cx="66" cy="64" r="6" fill="currentColor" />
      </g>
      <path transform="translate(0,295.034) scale(0.11246,-0.11246) translate(-68.00,-1518.00)" fill="currentColor"
        d="M361 -16Q241 -16 177.5 34.0Q114 84 91.0 173.5Q68 263 68 383V1500H428V425Q428 335 442.0 299.5Q456 264 508 264Q564 264 578.5 314.0Q593 364 593 443V1500H950V0H592V160Q558 74 510.5 29.0Q463 -16 361 -16ZM1128.816 0V1500H1492.816V1333Q1518.816 1420 1584.816 1469.0Q1650.816 1518 1750.816 1518V1219Q1706.816 1219 1645.816 1209.5Q1584.816 1200 1538.816 1183.5Q1492.816 1167 1492.816 1147V0ZM2284.632 -16Q1840.632 -16 1840.632 434V553H2200.632V377Q2200.632 326 2220.632 297.0Q2240.632 268 2284.632 268Q2362.632 268 2362.632 385Q2362.632 483 2321.632 531.5Q2280.632 580 2221.632 625L2030.632 772Q1940.632 842 1893.632 920.0Q1846.632 998 1846.632 1137Q1846.632 1266 1908.132 1350.0Q1969.632 1434 2071.132 1475.0Q2172.632 1516 2290.632 1516Q2726.632 1516 2726.632 1081V1053H2356.632V1110Q2356.632 1155 2341.132 1197.0Q2325.632 1239 2280.632 1239Q2204.632 1239 2204.632 1159Q2204.632 1078 2268.632 1032L2490.632 870Q2594.632 795 2665.132 692.0Q2735.632 589 2735.632 418Q2735.632 206 2615.132 95.0Q2494.632 -16 2284.632 -16Z" />
    </svg>
  )
}

export default UrsLogo
